import { isUnderReview } from '@/db/types/document';

export interface LockedOnlineCopy {
  chip: string;
  bannerTitle: string;
  bannerBody: string;
  modalTitle: string;
  modalBody: string;
  onlineColumn: string;
  syncMessage: string;
}

const COMPLETED: LockedOnlineCopy = {
  chip: 'Completed Online',
  bannerTitle: 'Completed elsewhere',
  bannerBody: 'This document was completed on another device or online while you were editing it. Editing is disabled and the completed version is shown, but your unsaved edits are preserved. Review them to carry them into a new document or discard them.',
  modalTitle: 'Completed online',
  modalBody: 'This document was completed online while your edits were still on this device. A completed document can no longer be edited, so your offline changes could not be saved. You can start a new document from your edits, or discard them and keep the completed version.',
  onlineColumn: 'Online (completed)',
  syncMessage: 'This document was completed in the online app; your offline edits could not be saved.',
};

const SENT_FOR_REVIEW: LockedOnlineCopy = {
  chip: 'Sent for Review',
  bannerTitle: 'Sent for review elsewhere',
  bannerBody: 'This document was sent for review on another device or online while you were editing it. Editing is disabled and the version in review is shown, but your unsaved edits are preserved. Review them to carry them into a new document or discard them. Open it on the web to see comments.',
  modalTitle: 'Sent for review online',
  modalBody: 'This document was sent for review online while your edits were still on this device. A document in review can no longer be edited here, so your offline changes could not be saved. You can start a new document from your edits, or discard them and keep the version in review.',
  onlineColumn: 'Online (in review)',
  syncMessage: 'This document was sent for review in the online app; your offline edits could not be saved.',
};

export function lockedOnlineCopy(doc: { status?: string }): LockedOnlineCopy {
  return isUnderReview(doc) ? SENT_FOR_REVIEW : COMPLETED;
}
